import { Injectable } from '@angular/core';
import { AuthService } from './auth.service';
import { HttpClient } from '@angular/common/http';
import { environment } from '../../environments/environment';
import { map } from 'rxjs/operators';
import { of } from 'rxjs';
import { Vehicle } from '../services/archive-downloader/component-models/vehicle';
import { Position } from '../models/api/vehicle-position.model';

export interface Group {
  id: number;
  name: string;
}

export interface Pharmacy {
  baseStationsIds: string[];
  name: string;
  id: number;
  uuid: string;
  groups: number[];
  position?: Position[];
}

// maxxx
// export const mockPharmacy: Pharmacy[] = [
//   {
//     baseStationsIds: ['45001', '45163'],
//     name: 'Apteka test 1',
//     id: 1,
//     groups: [
//       { id: 3184, name: 'testGroup1' } as Group,
//       { id: 2, name: 'testGroup2' } as Group,
//     ],
//   },
//   {
//     baseStationsIds: ['44887', '44809', '44999'],
//     name: 'Test 2',
//     id: 2,
//     groups: [
//       { id: 1, name: 'testGroup21' } as Group,
//       { id: 2, name: 'testGroup22' } as Group,
//     ],
//   },
// ];

// test
export const mockPharmacy: Pharmacy[] = [
  {
    baseStationsIds: ['60334', '60337'],
    name: 'Apteka test 1',
    id: 1,
    uuid: '1213',
    groups: [],
  },
  {
    baseStationsIds: ['60329', '60334'],
    name: 'Test 2',
    id: 2,
    uuid: '122312',
    groups: [],
  },
];

@Injectable({
  providedIn: 'root',
})
export class PharmacyService {
  constructor(
    private httpClient: HttpClient,
    private authService: AuthService
  ) {}
  private readonly urlPharmacy = environment.baseUrl + environment.api + 'sets';

  private pharmacyUrl =
    environment.baseUrl + environment.api + 'sets' + environment.surfix;

  private updatePharmacyBaseStationUrl =
    environment.baseUrl + environment.api + 'sets' + environment.surfix;

  private pharmacyGroupsUrl =
    environment.baseUrl + environment.api + 'sets/groups' + environment.surfix;

  getPharmacyList() {
    // return of(mockPharmacy);
    return this.httpClient
      .get<Pharmacy[]>(this.urlPharmacy, {
        headers: this.authService.getJwtAuthHeaders(),
      })
      .pipe(
        map((pharmacy) => {
          return pharmacy;
        })
      );
  }
  getWithEmptyPharmacyList() {
    // return of(mockPharmacy);
    return this.httpClient
      .get<Pharmacy[]>(this.urlPharmacy + "/all", {
        headers: this.authService.getJwtAuthHeaders(),
      })
      .pipe(
        map((pharmacy) => {
          return pharmacy;
        })
      );
  }

  addPharmacy(pharmacyName) {
    const headers = this.authService.getJwtAuthHeaders();

    return this.httpClient.post(
      this.updatePharmacyBaseStationUrl,
      JSON.stringify({
        name: pharmacyName,
        baseStationsIds: [],
      }),
      {
        headers: headers,
      }
    );
  }

  deletePharmacy(pharmacy: Pharmacy) {
    const headers = this.authService.getJwtAuthHeaders();

    return this.httpClient.delete(
      this.updatePharmacyBaseStationUrl + '/' + pharmacy.id,
      {
        headers: headers,
      }
    );
  }

  changePharmacyName(group, newName) {
    return this.updatePharmacy(group.id, {
      name: newName,
      baseStationsIds: group.vehiclesIds,
    });
  }

  getPharmacyGroups() {
    return this.httpClient
      .get<any>(this.pharmacyGroupsUrl, {
        headers: this.authService.getJwtAuthHeaders(),
      })
      .pipe(
        map((pharmacy) => {
          return pharmacy;
        })
      );
  }

  updatePharmacyGroup(groups) {
    const headers = this.authService.getJwtAuthHeaders();

    groups.baseStationsIds = groups.vehiclesIds.map((id) => {
      return id.toString();
    });

    delete groups.vehiclesIds;

    return this.httpClient.put(
      `${this.pharmacyGroupsUrl}`,
      JSON.stringify(groups),
      {
        headers: headers,
      }
    );
  }

  updatePharmacy(pharmacyId, pharmacy) {
    const headers = this.authService.getJwtAuthHeaders();

    pharmacy.id = pharmacyId;

    return this.httpClient.put(
      `${this.updatePharmacyBaseStationUrl}`,
      JSON.stringify(pharmacy),
      {
        headers: headers,
      }
    );
  }
}
